














































































































































































import Vue from "vue";
import moment from "moment";

import { MODULE_COLORS } from "@/utility/Constants";

// Components
import DeviceTree from "@/components/DeviceTree/index.vue";
import { mapGetters, mapState } from "vuex";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { SaveCaosUserSyncConfigurationCommand } from "@/model/communication/caosConfiguration/SaveCaosUserSyncConfigurationCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { CaosSynchronizationConfiguration } from "@/model/data/caosConfiguration/CaosSynchronizationConfiguration";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";

export default Vue.extend({
    components: {
        DeviceTree,
    },
    props: {
        showDialog: Boolean,
        installations: Array,
    },
    data() {
        return {
            moment,
            MODULE_COLORS,
            loadingSaveRequest: false,

            selectedRole: "-",
            syncWithInstallationSelected: [],
            editSelectedInstallation: false,
            syncAt: null,
            editSyncTime: false,
            showAlert: false,
            alertType: "",
            alertMessage: "",
        };
    },
    watch: {
        installations: {
            handler(value) {
                this.showAlert = false;
                if (value && value.length == 1) {
                    if (!value.syncTime) this.syncAt = null;
                    if (!value.syncToInstallationName) this.syncWithInstallationSelected = [];
                } else {
                    this.syncAt = null;
                    this.syncWithInstallationSelected = [];
                }

                this.setup();
            },
            deep: true,
        },
    },
    computed: {
        ...mapGetters(["userTimeFormat"]),
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),
        showEditConfigurationDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
        canSave() {
            if (this.selectedRole != "master" && this.selectedRole != "slave") return false;
            if (this.selectedRole == "slave" && this.syncWithInstallationSelected.length != 1) return false;
            if (this.selectedRole == "master" && (!this.syncAt || this.syncAt.length != 5)) return false;
            return true;
        },
        flattenedDeviceTree() {
            if (this.deviceTree) {
                let stack = [];
                let result = [];
                stack.push(this.deviceTree[0]);
                while (stack.length > 0) {
                    let node = stack.pop();
                    result.push(node);
                    if (node.children) {
                        for (let child of node.children) {
                            stack.push(child);
                        }
                    }
                }
                return result;
            }
            return [];
        },
        availableRole() {
            let availableRole = [];
            if (this.installations && this.installations.length == 1) availableRole = [{ text: this.$t("common.master"), value: "master" }];
            availableRole.push({ text: this.$t("common.copyCapitol"), value: "slave" });
            return availableRole;
        },
    },
    methods: {
        async sendRequestSaveConfiguration() {
            this.loadingSaveRequest = true;
            try {
                let newConfig = this.createConfig();
                let response: ApiGenericResponse = await new SaveCaosUserSyncConfigurationCommand(
                    newConfig,
                    this.installations.map((i) => i.name)
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message) {
                        switch (response.message) {
                            case CReqExecutionResultEnum.OperationNotAvailable:
                                this.alertMessage = this.$t("caos_user_sync.notAMaster");
                                this.alertType = "error";
                                this.showAlert = true;
                                break;
                            case CReqExecutionResultEnum.ServerError:
                                this.alertMessage = this.$t("caos_user_sync.genericError");
                                this.alertType = "error";
                                this.showAlert = true;
                                break;
                            default:
                                break;
                        }
                    } else {
                        this.showEditConfigurationDialog = false;
                        this.$emit("reload");
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending SaveCaosUserSyncConfiguration request ", e);
            }
            this.loadingSaveRequest = false;
        },
        setup() {
            if (this.installations && this.installations.length == 1) {
                let installation = this.installations[0];
                if (installation.isMaster == null) this.selectedRole = null;
                else if (installation.isMaster) this.selectedRole = "master";
                else this.selectedRole = "slave";

                if (installation.syncToInstallationName)
                    this.syncWithInstallationSelected = [
                        this.flattenedDeviceTree.find((n) => n.name == installation.syncToInstallationName && n.type == DeviceTreeNodeTypeEnum.Device),
                    ];
                if (installation.syncTime) this.syncAt = this.moment.utc(installation.syncTime, "HH:mm").local().format("HH:mm");
            } else {
                this.selectedRole = "slave";
            }

            this.editSelectedInstallation = false;
            this.editSyncTime = false;
        },
        createConfig(): CaosSynchronizationConfiguration {
            let newConfig = new CaosSynchronizationConfiguration();
            newConfig.installationName = this.installations[0].name;
            if (this.selectedRole == "master") {
                newConfig.isMaster = true;
                newConfig.syncTime = this.moment(this.syncAt, "HH:mm").utc().format("HH:mm");
            } else if (this.selectedRole == "slave") {
                newConfig.isMaster = false;
                newConfig.syncToInstallationName = this.syncWithInstallationSelected[0].name;
            }
            return newConfig;
        },
        openNewTab() {
            let routeData = this.$router.resolve({
                name: this.$route.name,
            });
            window.open(routeData.href, "_blank");
        },
    },
    created() {
        this.setup();
    },
});
